export const SITE_PUSH_BUTTON_EVENTS_CARD_FRENCH_LOCALE = {
  title: "Appui boutton",
  lastPush: "Dernier appui",
  count: "Nombre d'appuis 72h",
};
